import { css } from 'styled-components'
import { colors } from '@/styles'

const lockedStyle = css`
  filter: blur(10px);
  color: ${colors.black};
  background-color: ${colors.grey96};
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: not-allowed;
`

const styles = {
  lockedStyle
}

export default styles
